import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import '@/style/element_vars.scss'
import '@/style/element_override.scss'
import '@/style/common.scss'
import Vuebar from 'vuebar';
import VueCalendarHeatmap from 'vue-calendar-heatmap'
import 'vue-calendar-heatmap/dist/vue-calendar-heatmap.css'
import VueApexCharts from 'vue-apexcharts'
import VueEllipsis from 'vue-ellipsis'


import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(fas)

Vue.use(VueEllipsis)
Vue.use(ElementUI);
Vue.use(Vuebar);
Vue.use(VueCalendarHeatmap)

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false

window.empty = (obj) => typeof (obj) === 'undefined' || obj === null || obj === 0 || (!!obj.length && obj.length === 0)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
